var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 120,
    viewBox: "0 0 104 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kvkr1or8ra"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 51",
    style: {
      fill: "#fff"
    },
    d: "M0 0h43.58v43.58H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9411"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9414"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 40",
    style: {
      fill: "#043c50"
    },
    d: "M0 0h104v120H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37",
    transform: "translate(30.115 37.787)",
    style: {
      clipPath: "url(#kvkr1or8ra)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46",
    d: "M23.645 39.866a18.127 18.127 0 0 1-4.8-.147l-2.683 3.559-6.726-3.028.887-4.369a18.073 18.073 0 0 1-3.3-3.5L2.613 33 0 26.107l3.714-2.461a18.019 18.019 0 0 1 .148-4.805L.3 16.159l3.029-6.723 4.369.885a18.059 18.059 0 0 1 3.5-3.294l-.621-4.412L17.474 0l2.461 3.714a18.023 18.023 0 0 1 4.805.148L27.421.3l6.724 3.027-.886 4.373a18.106 18.106 0 0 1 3.3 3.5l4.411-.62 2.615 6.9-3.714 2.461a18.021 18.021 0 0 1-.148 4.805l3.56 2.683-3.033 6.716-4.369-.887a18.066 18.066 0 0 1-3.5 3.3L33 40.966l-6.893 2.614zm.635-10.56a7.91 7.91 0 1 0-10.2-4.593 7.911 7.911 0 0 0 10.2 4.593",
    style: {
      fillRule: "evenodd",
      fill: "#fff"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.ab871aaf024eb08029cba41665737a7c.svg";
export { ForwardRef as ReactComponent };